export const LIST_CUSTOMER_MAILING_LIST = 'LIST_CUSTOMER_MAILING_LIST'